module.exports = __webpack_public_path__ + "img/502-2971ce.png";